import MOMENT from "moment-timezone";

const OUTPUTS = document.querySelectorAll(".current-status");

const HOURS = [
    {
        open: "0000",
        close: "0000",
    },
    {
        open: "0900",
        close: "1700",
    },
    {
        open: "0900",
        close: "2100",
    },
    {
        open: "0900",
        close: "2100",
    },
    {
        open: "0900",
        close: "2100",
    },
    {
        open: "0900",
        close: "1700",
    },
    {
        open: "0900",
        close: "1300",
    },
];

const TODAY = MOMENT().tz("America/New_York").format("d");
const NOW   = MOMENT().tz("America/New_York").format("HHmm");

const HOLIDAYS = [
    "12252023",
    "01012024",
    "01152024",
    "02192024",
    "05272024",
    "06192024",
    "07042024",
    "09022024",
    "10142024",
    "11112024",
    "11272024", // close at 5pm
    "11282024",
    "11292024",
    "12242024", // close at 5pm
    "12252024",
    "12312024"  // close at 5pm
];

const TODATE = MOMENT().tz("America/New_York").format("MMDDYYYY");

OUTPUTS.forEach((output) => {
    if ((HOURS[TODAY].open <= NOW && HOURS[TODAY].close >= NOW) && (HOLIDAYS.includes(TODATE) === false)) {
        output.innerHTML = "OPEN";
    } else if ((HOURS[TODAY].open <= NOW && 1700 >= NOW) && (HOLIDAYS.includes(TODATE) === true ) && (11272024 == TODATE || 12242024 == TODATE || 12312024 == TODATE)) {
        output.innerHTML = "OPEN";
    } else {
        output.innerHTML = "CLOSED";
    }
});
